import React from "react";

import styles from "./player-metadata.module.scss";
import PropTypes from "prop-types";

const PlayerMetadata = ({
  coverImgUrl,
  title,
  issue = { year: "", nr: "" },
  nrUbungen,
}) => {
  return (
    <div className={styles.root}>
      <div className={styles.coverImgContainer}>
        <img src={coverImgUrl} alt={title} />
      </div>
      <div className={styles.infoContainer}>
        <div className={styles.headInfo}>
          <div className={styles.headIssuenr}>
            Ausgabe {issue.nr} / {issue.year}
          </div>
          <div className={styles.headTitle}>{title}</div>
          <hr />
          <div className={styles.headTrackinfo}>
            <span>{nrUbungen} Übungen</span>, <br />
          </div>
        </div>
      </div>
    </div>
  );
};

PlayerMetadata.defaultProps = {};

PlayerMetadata.propTypes = {
  coverImgUrl: PropTypes.string,
};

export default PlayerMetadata;
